











































import { tns } from "tiny-slider/src/tiny-slider";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        BlogCard: () => import("./card.vue")
    }
})
export default class BlogSlider extends Vue {
    @Prop({ default: "dark" }) theme!: string;

    $refs!: Vue["$refs"] & {
        slider: HTMLElement;
        controls: HTMLElement;
    };

    slider: any = null;

    loading: boolean = false;

    params: BlogParams = { per_page: 3, page: 1 };

    articles: Article[] = [];

    private mounted() {
        this.getArticles();
    }

    private getArticles() {
        this.loading = true;
        // @ts-ignore
        axios
            .get("/api/articles", { params: { ...this.params } })
            .then((response: any) => this.initSlider(response.data.data))
            .finally(() => (this.loading = false));
    }

    private initSlider(articles: Article[]) {
        this.articles = articles;
        this.$nextTick(() => {
            this.slider = tns({
                container: this.$refs.slider,
                items: 1.1,
                gutter: 24,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: true,
                controlsContainer: this.$refs.controls,
                nav: false,
                swipeAngle: false,
                responsive: {
                    1024: {
                        items: 3,
                        gutter: 24
                    }
                }
            });
        });
    }
}
